/**
 * Acting as / viewing as another user — ADR-006 as amended by the operator (decisions 14–18, A5):
 * a property of the existing session, time-boxed (30 minutes), with a mandatory reason, audited with both
 * people. The member is NOT notified and does not see the history; managers see it in the audit trail and in
 * the acting-as log. `view` mode is read-only: every write is refused (and the database transaction is
 * read-only too).
 */
import { z } from 'zod';
import { PageQuery, Timestamp, Uuid, page } from './common.js';
import { UserRef } from './users.js';
import { ActingAs } from './me.js';
import { Capability } from './roles.js';
export const StartActAsBody = z
    .object({
    user_id: Uuid,
    reason: z.string().trim().min(5, 'Say why, in a few words — it is stored with every change you make').max(300),
    mode: z.enum(['act', 'view']).default('act'),
})
    .strict();
export const ActAsResponse = z
    .object({
    acting_as: ActingAs.nullable(),
    /** What this session may do now (the target's capabilities minus what is never allowed while acting). */
    effective_capabilities: z.array(Capability),
})
    .meta({ id: 'ActAsResponse' });
export const ActAsLogEntry = z
    .object({
    id: Uuid,
    real_user: UserRef,
    target: UserRef,
    mode: z.enum(['act', 'view']),
    reason: z.string(),
    started_at: Timestamp,
    expires_at: Timestamp,
    /** `null` while running; for an expired session, the expiry. */
    ended_at: Timestamp.nullable(),
    /** `signed_out`: the session itself ended (signed out, or its sign-in was revoked by a password change). */
    end_reason: z.enum(['stopped', 'expired', 'replaced', 'access_changed', 'signed_out']).nullable(),
})
    .meta({ id: 'ActAsLogEntry' });
export const ActAsLogPage = page(ActAsLogEntry).meta({ id: 'ActAsLogPage' });
export const ActAsLogQuery = PageQuery.extend({
    real_user_id: Uuid.optional(),
    target_id: Uuid.optional(),
    from: Timestamp.optional(),
    to: Timestamp.optional(),
});
//# sourceMappingURL=actas.js.map